module.exports = __webpack_public_path__ + "img/rivendell-3018-10-20.54975848.jpg";